module.exports = __webpack_public_path__ + "img/8O0A42481.29a6a78a.png";